import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const useGoBack = (fallback?: string) => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    if (fallback && location.key === "default") {
      navigate(fallback, { replace: true });
    } else {
      navigate(-1);
    }
  }, [fallback, location.key, navigate]);
};
